import { Link, Outlet, useLocation } from "react-router";
import { useAppState } from "../../context";
import { UserType } from "../../types";

export const AccountLayout = () => {
    const [user] = useAppState<UserType>('user');
    const location = useLocation();

    if (!user) {
        return <div className="inside-wrapper">Please sign in to access your account.</div>;
    }

    const isActive = (path: string) => {
        if (path === '/account') {
            return location.pathname === path || location.pathname === '/account/change-password' ? 'm-current' : '';
        }
        return location.pathname === path ? 'm-current' : '';
    };

    return (
        <section className="section">
            <div className="inside-wrapper">
                <ul className="accnav">
                    <li className="accnav__item">
                        <Link to="/account/cart" className={`accnav__link ${isActive('/account/cart')}`}>Cart</Link>
                    </li>
                    <li className="accnav__item">
                        <Link to="/account/orders" className={`accnav__link ${isActive('/account/orders')}`}>Orders</Link>
                    </li>
                    <li className="accnav__item">
                        <Link to="/account/wishlist" className={`accnav__link ${isActive('/account/wishlist')}`}>Wishlist</Link>
                    </li>
                    <li className="accnav__item">
                        <Link to="/account/coupons" className={`accnav__link ${isActive('/account/coupons')}`}>Coupons</Link>
                    </li>
                    <li className="accnav__item">
                        <Link to="/account" className={`accnav__link ${isActive('/account')}`}>Personal Information</Link>
                    </li>
                    <li className="accnav__item">
                        <Link to="/account/settings" className={`accnav__link ${isActive('/account/settings')}`}>Settings</Link>
                    </li>
                    {/*
                    <li className="accnav__item">
                        <Link to="/account/support" className={`accnav__link ${isActive('/account/support')}`}>Support</Link>
                    </li>
                    */}
                </ul>
                <Outlet />
            </div>
        </section>
    );
};

export default AccountLayout; 